import * as filterHeaderTypes from '../../webcommon/header/filterheader/propTypes';

export const filterDefinitions = [
    {
        id: 'prodClass',
        title: 'Prod Class',
        type: filterHeaderTypes.filterTypes.radioList,
        defaultValue: [],
        availableValues: undefined,
        availableValuesLocation: '/SystemInfo/ModelProducts',
        server: true
    }
];

export const defaultFilters = [
    {
        value: [],
        definition: filterDefinitions.find(def => def.id === 'prodClass')
    }
];
